module.exports = __webpack_public_path__ + "img/close.e579cf31.svg";